import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const CreateFunctionSuperAdmin = lazy(() => import("./CreateFunctionSuperAdmin"));
const DetailFunctionSuperAdmin = lazy(() => import("./DetailFunctionSuperAdmin"));
const ViewFunctionSuperAdmin = lazy(() => import("./ViewFunctionSuperAdmin"));

const L = DefaultLayout;
const W = withSuspense;

export function getFunctionSuperadminRoutes() {
  return [
    { path: "/create-function-superadmin/:projectId", layout: L, element: W(CreateFunctionSuperAdmin) },
    { path: "/create-function-superadmin", layout: L, element: W(CreateFunctionSuperAdmin) },
    { path: "/view-function-superadmin", layout: L, element: W(ViewFunctionSuperAdmin) },
    { path: "/function/:id/edit", layout: L, element: W(CreateFunctionSuperAdmin) },
    { path: "/function/:id/details", layout: L, element: W(DetailFunctionSuperAdmin) },
    { path: "/functions/:id", layout: L, element: W(ViewFunctionSuperAdmin) },
  ];
}
